export default __webpack_public_path__ + "static/20240125-f5b3135c8c81ade68a3b4b9ffb5ab598.png";